<template>
  <div>
    <form action="#" class="form form--location" @submit="submitHandler">

      <fieldset>
        <div class="form-group form-group--big form-group--select">
          <multiselect v-if="locations && locations.length > 0"
                       v-model="selected"
                       :options="results"
                       class="multiselect--locations"
                       :placeholder="lexicon && lexicon.location_or_postal_code"
                       :custom-label="completeAddress"
                       :internal-search="false"
                       :loading="isLoading"
                       @select="onSelect"
                       @search-change="asyncFind"
                       track-by="id">
            <template slot="option" slot-scope="props">
              <span class="multiselect__option-text">{{`${props.option.address_postal_code ? 'CH-' + props.option.address_postal_code : ''} ${props.option.address_city}${props.option.address_street ? ', ' + props.option.address_street : ''}`}}</span>
            </template>
            <span slot="noResult" v-if="lexicon && lexicon.hasOwnProperty('location_no_result')">{{lexicon.location_no_result}}</span>
          </multiselect>

          <button type="submit"
                  class="action action--submit-absolute"
                  value="Submit">
            <v-icon name="location"></v-icon>
            <span class="visually-hidden">Submit</span>
          </button>
        </div>
      </fieldset>
    </form>

    <div class="form-group">
      <a class="action action--button"
         v-if="parsedLink"
         :href="parsedLink.url"
         :target="parsedLink.target == '_blank' ? '_blank' : '_self'">
        <span class="action__text">{{parsedLink.title}}</span>
      </a>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import {getPosts, getLexicon} from "../rest-service/rest-service";
import AsyncComputed from "vue-async-computed";
import VIcon from '../VIcon/vue-icon.vue';
import staticVars from '../static-vars/static-vars'
import slugify from 'slugify';
const templateUrl = staticVars.templateUrl

export default {
  name: "VLocations",
  components: {VIcon, Multiselect},

  data () {
    return {
      lexicon: {},
      locations: [],
      results: [],
      selected: null,
      isLoading: false,
      keywords: []
    }
  },

  props: {
    rawLink: String
  },

  mounted() {
    //console.log(JSON.parse(this.rawLink));
    fetch(`${templateUrl}/assets/data/garages.json`)
        .then((response) => {
      return response.json()
    }).then((json) => {
      //console.log(json)
      this.keywords = json
    }).catch((ex) => {
      console.log('parsing failed', ex)
    })

    getPosts({
      post_type : 'location',
      post_status : 'publish',
      posts_per_page : -1,
      orderby: 'menu_order',
      order: 'DESC',
      suppress_filters: 0,
      lang: this.lang
    }, (response) => {
      this.locations = response.data
      this.results = response.data
    })

    getLexicon(this.lang,(response) => {
      this.lexicon = response.data
    })
  },

  computed: {
    parsedLink () {
      return JSON.parse(this.rawLink)
    },

    lang () {
      return document.documentElement.lang.split('-')[0]
    }
  },

  methods: {
    completeAddress ({address_postal_code, post_title, address_street}) {
      return `${address_postal_code ? 'CH-' + address_postal_code : ''} ${post_title}${address_street ? ', ' + address_street : ''} `
    },

    submitHandler (event) {
      event.preventDefault()
      if (this.selected) {
        window.location.href = this.selected.link
      }
    },

    onSelect(selectedOption) {
      window.location.href = selectedOption.link
    },

    toSLug(text) {
      return slugify(text, {
        lower: true,
        strict: true,
      })
    },

    asyncFind (query) {
      this.isLoading = true

      const lowerCaseQuery = query.toLowerCase()

      const resultFromGarage = this.keywords.find(item => {
        return item.plz.toString().startsWith(query) || (this.toSLug(item.ort)).indexOf(this.toSLug(lowerCaseQuery)) > -1
      })

      const temp = this.locations.filter(item => {
        //return (item.hasOwnProperty("keywords") && (item.keywords.toLowerCase()).indexOf(lowerCaseQuery) > -1) ||
        return resultFromGarage?.standort === item.post_title ||
            (item.address_city.toLowerCase()).indexOf(lowerCaseQuery) > -1 ||
            (item.address_postal_code.toLowerCase()).indexOf(lowerCaseQuery) > -1 ||
            (item.address_street.toLowerCase()).indexOf(lowerCaseQuery) > -1
      })

      if (temp.length) {
        this.results = temp
      } else {
        this.results = []
      }

      if (!query) {
        this.results = this.locations;
      }

      this.isLoading = false
    },
  }
}
</script>
